import * as React from "react";
import styled from "styled-components";
import * as S from "@styled";
import theme from "styled-theming";
import { ThemeType } from "shared/styles/theme";

const agentGroupIndicatorColor = theme("mode", {
    [ThemeType.light]: S.Colors.grey_1,
    [ThemeType.dark]: S.Colors.grey_4
})

const StyledAgentGroupIndicator = styled.li`
    font-weight: 400;
    font-size: 1rem;
    line-height: 19px;
    padding-right: 26px !important;
    color: ${agentGroupIndicatorColor};
`;

const AgentGroupIndicator: React.FC<IAgentGroupIndicatorProps> = (props) => {
    return (
        <StyledAgentGroupIndicator>
            {props.environmentDisplayName || ''} / {props.agentGroupDisplayName || ''}
        </StyledAgentGroupIndicator>
    )
}

export interface IAgentGroupIndicatorProps {
    environmentDisplayName: string | undefined;
    agentGroupDisplayName: string | undefined;
}

export default AgentGroupIndicator;